import { apiRequest } from './apiClient';
import { Category, Unit, Product, ProductCreateRequest, ProductUpdateRequest } from '../types/product';

export const getProductCategories = async (): Promise<Category[]> => {
  const response = await apiRequest.get('api/products/categories/list', { requiresHouseholdId: false });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Categories retrieval failed');
  }

  return response.json();
};

export const getProductUnits = async (): Promise<Unit[]> => {
  const response = await apiRequest.get('api/products/units/list', { requiresHouseholdId: false });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Units retrieval failed');
  }

  return response.json();
};

export const getProducts = async (): Promise<Product[]> => {
  const response = await apiRequest.get('api/products');

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Products retrieval failed');
  }

  return response.json();
};

export const getProduct = async (productId: string): Promise<Product> => {
  const response = await apiRequest.get(`api/products/${productId}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Product retrieval failed');
  }

  return response.json();
};

export const createProduct = async (data: ProductCreateRequest): Promise<{ message: string; id: string }> => {
  const response = await apiRequest.post('api/products', data);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Product creation failed');
  }

  return response.json();
};

export const updateProduct = async (productId: string, data: ProductUpdateRequest): Promise<void> => {
  const response = await apiRequest.patch(`api/products/${productId}`, data);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Product update failed');
  }
};

export const deleteProduct = async (productId: string): Promise<void> => {
  const response = await apiRequest.delete(`api/products/${productId}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Product deletion failed');
  }
};